export function convertToUrlSlug(str) {
    const from = "ąàáäâèéëêìíïîòóöôùúüûñçćłężźńś",
        to = "aaaaaeeeeiiiioooouuuuncclezzns",
        expression = new RegExp(from.split("").join("|"), "g");

    return str
        .toLowerCase()
        .replace(expression, m => {
            return to[from.indexOf(m)];
        })
        .replace(/[^a-z0-9-]+/g, "-");
}
